<template>
  <sl-content 
    pagetype="1" 
    pagename="slitdigitalexperience"
    :title="$t('sl.itandxpdigitale.title') "
    titlecolor="darkgreen"
  />
</template>

<script>
import Vue from 'vue';
import SlContent from '@/views/Layout/SlContent';

  export default {
    name: 'it-digital-experience',
    components: {
      SlContent
    },
     data() {
      return {
      };
    },
  };
</script>

